import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { deleteLoyaltyProgramApi } from './deleteLoyaltyProgram.api'
import deleteLoyaltyProgramInitialState from './deleteLoyaltyProgram.initialState'
import { DeleteLoyaltyProgramErrorResponse, DeleteLoyaltyProgramRequestPayload } from './deleteLoyaltyProgram.types'

export const deleteLoyaltyProgram = createAsyncThunk(
  urls.profile.deleteLoyaltyProgram,
  async (payload: DeleteLoyaltyProgramRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await deleteLoyaltyProgramApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const deleteLoyaltyProgramSlice = createSlice({
  name: urls.profile.deleteLoyaltyProgram,
  initialState: deleteLoyaltyProgramInitialState,
  reducers: {
    resetDeleteLoyaltyProgram: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteLoyaltyProgram.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(deleteLoyaltyProgram.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(deleteLoyaltyProgram.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as DeleteLoyaltyProgramErrorResponse
        state.success = null
      })
  }
})

export const { actions: deleteLoyaltyProgramActions, reducer: deleteLoyaltyProgramReducer } = deleteLoyaltyProgramSlice
export const { resetDeleteLoyaltyProgram } = deleteLoyaltyProgramActions
export default deleteLoyaltyProgramSlice.reducer
